import React from "react";
import { connect } from "react-redux";
import { getters } from "Portal/FollowupForm/model";
import { Div } from "components/Base";
import { getIsEditing } from "../selectors";

const decorate = connect(state => ({
  allowEdits: getters.allowEdits(state),
  closeAt: getters.closeAt(state),
  isClosed: getters.isClosed(state),
  isEditing: getIsEditing(state),
  previewing: getters.previewing(state),
  markCompletedAsViewOnly: getters.markCompletedAsViewOnly(state)
}));

const CloseAt = ({
  closeAt,
  isClosed,
  isEditing,
  previewing,
  allowEdits,
  markCompletedAsViewOnly = false
}) => {
  let message;
  const CLOSE_AT_COPY = {
    completedViewOnly: "This form is completed and now in view-only mode",
    viewOnlyUnassigned:
      "Form is in view-only mode and must be assigned to a portal to be completed",
    rejectingEdits: "Edits to your submission are no longer being accepted",
    rejectingSubmissions: "Submissions are no longer being accepted",
    acceptingEdits: `Edits to your submission will be accepted until ${closeAt}`,
    acceptingSubmissions: `Submissions will be accepted until ${closeAt}`
  };
  if (previewing) {
    message = CLOSE_AT_COPY.viewOnlyUnassigned;
  } else if (isEditing && markCompletedAsViewOnly) {
    message = CLOSE_AT_COPY.completedViewOnly;
  } else if (isEditing && !allowEdits) {
    message = CLOSE_AT_COPY.rejectingEdits;
  } else if (isClosed) {
    message = isEditing
      ? CLOSE_AT_COPY.rejectingEdits
      : CLOSE_AT_COPY.rejectingSubmissions;
  } else {
    message = isEditing
      ? CLOSE_AT_COPY.acceptingEdits
      : CLOSE_AT_COPY.acceptingSubmissions;
  }
  return isClosed || closeAt || previewing || (isEditing && !allowEdits) ? (
    <Div bg="gray1" bra={2} p={3} mb={3} display="row.center.center">
      {message}
    </Div>
  ) : null;
};

export default decorate(CloseAt);
